import React from "react";
import "./styles/Toast.scss";

function Toast({ message }) {
  if (!message) return null;

  return (
    <div className="portfolio-toast" role="alert">
      <i className="fa fa-check-circle toast-icon" aria-hidden="true"></i>
      <span className="toast-msg font-mono">{message}</span>
    </div>
  );
}

export default Toast;
